import React, { useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import Center from "../../../../widget/common/ui/Center";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import Loader from "../../../../widget/common/ui/Loader";
import {
  imageExtensions,
  pdfExtensions,
  videoExtensions,
} from "../../../../const/FileExtensions";
import { Position } from "../../../../widget/common/ui/Stack";

const ImageDocumentPreviewBody = (props: { isModal?: boolean | false }) => {
  const isModal: boolean = props.isModal ?? false;
  const [loading, setLoading] = useState(true);

  let imageDocsSession: string =
    SessionStorage.getValue(StorageKeys.preview_image_document) || "";

  let fileUrl: string = "",
    //fileName: string = "",
    fileExt: string = "";

  if (UtilityHelper.isNotEmpty(imageDocsSession)) {
    const imageDoc: { title: string; url: string } =
      JSON.parse(imageDocsSession);

    let urlArr: Array<string> = imageDoc?.url.split("/");
    fileUrl = imageDoc?.url;
    //fileName = urlArr[urlArr.length - 1];

    urlArr = imageDoc?.url.split(".");
    fileExt = urlArr[urlArr.length - 1];
  }

  const handleLoaded = () => {
    setLoading(false);
  };

  const loaderHtml: JSX.Element = (
    <Position className="h-100 w-100" top={0} left={0} right={0}>
      <Center className="h-100 w-100">{Loader.normal()}</Center>
    </Position>
  );

  return (
    <div
      className={`h-100 ${
        imageExtensions.includes(fileExt) ? "d-center bgcolor-black" : ""
      }`}
    >
      {UtilityHelper.isEmpty(fileUrl) ? (
        <Center className="py-5 h-200 w-100">{Loader.normal()}</Center>
      ) : (
        <>
          {imageExtensions.includes(fileExt) ? (
            <div className="position-relative h-100 w-100 d-center">
              {loading && loaderHtml}
              <PhotoProvider>
                <PhotoView src={fileUrl}>
                  <img
                    src={fileUrl}
                    style={{ width: `100%`, cursor: "pointer" }}
                    onLoad={() => handleLoaded()}
                    alt=""
                  />
                </PhotoView>
              </PhotoProvider>
            </div>
          ) : videoExtensions.includes(fileExt) ? (
            <div
              className="position-relative"
              style={{
                height: loading ? "h-100" : isModal ? "70vh" : "inherit",
              }}
            >
              {loading && loaderHtml}
              <video
                controls={true}
                autoPlay={false}
                loop={false}
                muted={false}
                className="w-100 h-100"
                playsInline
                onLoadedData={handleLoaded}
                style={{
                  opacity: loading ? 0 : 1,
                }}
              >
                <source src={fileUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            <>
              {pdfExtensions.includes(fileExt) ? (
                <div className="position-relative h-100">
                  {loading && loaderHtml}
                  <iframe
                    src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                    width="100%"
                    style={{
                      height: loading ? 0 : `${isModal ? 65 : 80}vh`,
                      opacity: loading ? 0 : 1,
                    }}
                    onLoad={() => handleLoaded()}
                    title="preview"
                  />
                </div>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ImageDocumentPreviewBody;

// "https://www.aeee.in/wp-content/uploads/2020/08/Sample-pdf.pdf";
